(() => {
  if (window.top !== window.self) return;

  function initAuthSubmitLoading() {
    const forms = document.querySelectorAll('#CustomerLoginForm, #CustomerRegisterForm');
    if (!forms.length) return;

    forms.forEach((form) => {
      if (form.dataset.loadingBound === 'true') return;
      form.dataset.loadingBound = 'true';

      form.addEventListener(
        'submit',
        () => {
          const submitter = getSubmitter(form);
          if (!submitter) return;

          const loadingLabel = (submitter.dataset.loadingLabel || '').trim() || getFallbackLoadingLabel();
          setLoadingState(submitter, loadingLabel);

          // If some third-party script interrupts navigation, restore button text.
          const currentHref = window.location.href;
          window.setTimeout(() => {
            if (!document.contains(submitter)) return;
            if (window.location.href !== currentHref) return;
            restoreLoadingState(submitter);
          }, 4000);
        },
        { capture: true }
      );
    });
  }

  function getSubmitter(form) {
    const active = document.activeElement;
    if (
      active &&
      form.contains(active) &&
      ((active.tagName === 'BUTTON' && active.type === 'submit') ||
        (active.tagName === 'INPUT' && active.type === 'submit'))
    ) {
      return active;
    }

    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function setLoadingState(submitter, loadingLabel) {
    if (submitter.tagName === 'BUTTON') {
      if (!submitter.dataset.originalLabel) submitter.dataset.originalLabel = submitter.textContent.trim();
      submitter.textContent = loadingLabel;
    } else {
      if (!submitter.dataset.originalLabel) submitter.dataset.originalLabel = submitter.value;
      submitter.value = loadingLabel;
    }
    submitter.setAttribute('aria-busy', 'true');
    submitter.setAttribute('aria-disabled', 'true');
    submitter.style.pointerEvents = 'none';
    submitter.style.opacity = '0.85';
    submitter.classList.add('is-loading');
  }

  function restoreLoadingState(submitter) {
    if (submitter.tagName === 'BUTTON' && submitter.dataset.originalLabel) {
      submitter.textContent = submitter.dataset.originalLabel;
    } else if (submitter.tagName === 'INPUT' && submitter.dataset.originalLabel) {
      submitter.value = submitter.dataset.originalLabel;
    }
    submitter.removeAttribute('aria-busy');
    submitter.removeAttribute('aria-disabled');
    submitter.style.pointerEvents = '';
    submitter.style.opacity = '';
    submitter.classList.remove('is-loading');
  }

  function getFallbackLoadingLabel() {
    const lang = (document.documentElement.lang || '').toLowerCase();
    return lang.startsWith('it') ? 'Caricamento in corso...' : 'Loading...';
  }

  function initLoginErrorCleanup() {
    const loginForm = document.getElementById('CustomerLoginForm');
    const registerForm = document.getElementById('CustomerRegisterForm');
    if (!loginForm || !registerForm) return;

    const activeForm = getActiveFormFromUrl();

    if (activeForm === 'register') {
      clearFormErrors(loginForm);
      return;
    }

    if (activeForm === 'login') {
      clearFormErrors(registerForm);
      return;
    }

    const loginHasErrors = hasFormErrors(loginForm);
    const registerHasErrors = hasFormErrors(registerForm);

    if (!loginHasErrors || !registerHasErrors) return;

    // If we can't infer from URL, prefer form with field-level errors.
    if (registerForm.querySelector('[id^="RegisterForm-"][aria-invalid="true"], #RegisterForm-email-error, #RegisterForm-password-error')) {
      clearFormErrors(loginForm);
      return;
    }

    if (loginForm.querySelector('#LoginEmail[aria-invalid="true"], #LoginPassword[aria-invalid="true"]')) {
      clearFormErrors(registerForm);
      return;
    }

    // Final fallback: keep register errors and clear login duplicate summary.
    clearFormErrors(loginForm);
  }

  function getActiveFormFromUrl() {
    try {
      const url = new URL(window.location.href);
      const direct = (url.searchParams.get('auth_form') || '').toLowerCase();
      if (direct === 'login' || direct === 'register') return direct;

      const returnUrl = url.searchParams.get('return_url');
      if (!returnUrl) return '';

      const decoded = decodeURIComponent(returnUrl).toLowerCase();
      if (decoded.includes('auth_form=register') || decoded.includes('/account/register')) return 'register';
      if (decoded.includes('auth_form=login') || decoded.includes('/account/login')) return 'login';
    } catch (error) {
      return '';
    }

    return '';
  }

  function hasFormErrors(form) {
    return (
      !!form.querySelector('.form__message') ||
      !!form.querySelector('.errors') ||
      !!form.querySelector('ul li') ||
      !!form.querySelector('[aria-invalid="true"]')
    );
  }

  function clearFormErrors(form) {
    form.querySelectorAll('.form__message, .errors, ul, span[id$="-error"], span[id$="-email-error"]').forEach((node) => {
      // Keep labels and field wrappers untouched.
      if (node.closest('.field') && !node.matches('span[id$="-error"], span[id$="-email-error"]')) return;
      node.remove();
    });

    form.querySelectorAll('[aria-invalid], [aria-describedby]').forEach((input) => {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initLoginErrorCleanup();
        initAuthSubmitLoading();
      },
      { once: true }
    );
  } else {
    initLoginErrorCleanup();
    initAuthSubmitLoading();
  }
})();
